/* Configuration de Sentry */
import * as Sentry from "@sentry/browser";

const environment = (() => {
    const host = window.location.host;
    if (host.endsWith('.sitetest.pcsoft.com')) return 'staging';
    if (host === 'localhost' || host.startsWith('127.0.0.1') || host.endsWith('.pcsoft.com')) return 'local';
    return 'production';
})();

const sentryRelease = document
    .querySelector<HTMLMetaElement>('meta[name="sentry-release"]')
    ?.content;

Sentry.init({
    dsn: "https://4b8a433fca05444cf96cd1aedc602f5e@sentry.pcsoft.fr/16",
    environment: environment,
    release: sentryRelease,
    enabled: environment !== 'local',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    // Désactivation en local pour ne pas polluer les remontées d'erreurs
    // enabled: environment !== 'local',
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration()
    ],
    initialScope: {
        tags: {
            "scope": "frontend",
            "framework": "vanilla-js"
        }
    },
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
        'localhost',
        /^\//,
        /^https:\/\/(.*\.)?pcsoft\.com/,
        /^https:\/\/(.*\.)?pcsoft\.fr/,
    ],
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
})
